<template>
  <el-form ref="form" label-width="12%" v-loading="loading" :model="tjbForm">
    <CatProp v-if="catPropSection" :props="catPropSection.component.props" />
  </el-form>
</template>

<script>
import { getForm } from '@/servers/prod/center/tb';
import { generateSections } from './utils/sections';
import { _genPropsByForm } from './utils/data';
import CatProp from './components/ComplexItem/CatProp.vue';

import { mapActions, mapGetters } from 'vuex';
// 批量修改类目的入口
export default {
  components: {
    CatProp,
  },
  props: {
    categoryIds: Array,
  },
  provide() {
    return {
      tjbFormVm: this,
    };
  },
  data() {
    return {
      loading: false,
      catPropSection: null,
    };
  },
  computed: {
    ...mapGetters(['tjbForm', 'shops_defaultShopId']),
  },
  watch: {
    categoryIds(v) {
      if (v && v.length) {
        this.getUiData(v);
      }
    },
  },
  methods: {
    ...mapActions(['initTjbForm', 'updateTjbForm', 'clearTjbInfo', 'clearTjbForm_PData', 'updateCatePropShopIndex']),
    async getUiData() {
      let categoryIds = this.categoryIds;
      this.loading = true;
      this.catPropSection = null;
      const res = await getForm({
        shopId: this.shops_defaultShopId('tjb'),
        baseItemId: '',
        // catId: 162205,
        catId: categoryIds[categoryIds.length - 1],
      });
      if (!res) {
        this.loading = false;
        return false;
      }

      // 动态表单
      const { formData, formSections } = generateSections(res);
      this.initTjbForm(formData);
      this.updateTjbForm({
        categoryIds: categoryIds,
      });
      this.catPropSection = this._getCatPropSection(formSections.filter(item => item.children.length));
      this.loading = false;
    },
    updateCatPropUI() {
      this.updateCatePropShopIndex('tjb');
      this.getUiData();
    },
    _getCatPropSection(formSections) {
      // 先找基础信息模块
      const baseSections = formSections.find(item => item.title === '基础信息');
      if (!baseSections) return null;

      const catPropSection = baseSections.children.find(item => item.name === 'catProp');
      if (!catPropSection) return null;

      return catPropSection;
    },
    methods_getCatProps() {
      return _genPropsByForm(this.tjbForm);
    },
  },
};
</script>

<style>
</style>